"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlWidgetFormBuilder = void 0;
class HtmlWidgetFormBuilder {
    constructor(form, appendChild = false) {
        this.form = form;
        this.appendChild = appendChild;
    }
    addInput(label, inputId, inputType, required) {
        let row = this.form.createElement("div", div => div.classList.add("row"), this.appendChild);
        let input;
        row.createElement("div", div => div.classList.add("col-25"))
            .createElementAndAppend("label", element => {
            let labelElement = element;
            labelElement.textContent = label;
            labelElement.htmlFor = inputId;
        });
        row.createElement("div", div => div.classList.add("col-75"))
            .createElementAndAppend("input", element => {
            input = element;
            element.classList.add("input-search");
            input.type = inputType;
            input.required = required;
            input.id = inputId;
        });
        return input;
    }
    addTextInput(label, inputId, required, elementBuilder) {
        let input = this.addInput(label, inputId, "text", required);
        if (elementBuilder != null)
            elementBuilder(input);
        return this;
    }
    addDateInput(label, inputId, required, elementBuilder) {
        let input = this.addInput(label, inputId, "date", required);
        if (elementBuilder != null)
            elementBuilder(input);
        return this;
    }
    addUrlInput(label, inputId, required, elementBuilder) {
        let input = this.addInput(label, inputId, "url", required);
        if (elementBuilder != null)
            elementBuilder(input);
        return this;
    }
    addSelect(label, inputId, required, options, elementBuilder) {
        let row = this.form.createElement("div", div => div.classList.add("row"), this.appendChild);
        let select;
        row.createElement("div", div => div.classList.add("col-25"))
            .createElementAndAppend("label", element => {
            let labelElement = element;
            labelElement.textContent = label;
            labelElement.htmlFor = inputId;
        });
        row.createElement("div", div => div.classList.add("col-75"))
            .createElementAndAppend("select", element => {
            select = element;
            element.classList.add("input-search");
            select.required = required;
            select.id = inputId;
            for (let option of options) {
                let optionElement = document.createElement("option");
                optionElement.value = option.value;
                optionElement.textContent = option.text;
                select.options.add(optionElement);
            }
        });
        if (elementBuilder != null)
            elementBuilder(select);
        return this;
    }
    addResourceInput(label, inputId, required, browseButtonClicked, elementBuilder) {
        let row = this.form.createElement("div", div => div.classList.add("row"), this.appendChild);
        let input;
        row.createElement("div", div => div.classList.add("col-25"))
            .createElementAndAppend("label", element => {
            let labelElement = element;
            labelElement.textContent = label;
            labelElement.htmlFor = inputId;
        });
        row.createElement("div", div => div.classList.add("col-75"))
            .createElementAndAppend("button", button => {
            button.classList.add("btn");
            button.textContent = "Browse";
            button.addEventListener("click", (evt) => {
                evt.preventDefault();
                browseButtonClicked(input);
            });
        })
            .createElementAndAppend("input", element => {
            input = element;
            input.disabled = true;
            input.id = inputId;
        });
        if (elementBuilder != null)
            elementBuilder(input);
        return this;
    }
    addParagraph(paragraphText, elementBuilder) {
        let element = this.form.createElement("p", p => p.textContent = paragraphText);
        if (elementBuilder != null)
            elementBuilder(element.renderBody);
        return this;
    }
    addElement(elementName, elementBuilder) {
        let row = this.form.createElement("div", div => div.classList.add("row"), this.appendChild);
        row.createElement(elementName, elementBuilder);
        return this;
    }
    addFileInput(label, inputId, required, elementBuilder) {
        let input = this.addInput(label, inputId, "file", required);
        if (elementBuilder != null)
            elementBuilder(input);
        return this;
    }
    addTextarea(label, inputId, required, elementBuilder) {
        let row = this.form.createElement("div", div => div.classList.add("row"), this.appendChild);
        let textarea;
        row.createElement("div", div => div.classList.add("col-25"))
            .createElementAndAppend("label", element => {
            let labelElement = element;
            labelElement.textContent = label;
            labelElement.htmlFor = inputId;
        });
        row.createElement("div", div => div.classList.add("col-75"))
            .createElementAndAppend("textarea", element => {
            element.classList.add("input-search");
            textarea = element;
            textarea.required = required;
            textarea.id = inputId;
        });
        if (elementBuilder != null)
            elementBuilder(textarea);
        return this;
    }
}
exports.HtmlWidgetFormBuilder = HtmlWidgetFormBuilder;
//# sourceMappingURL=HTMLWidgetFormBuilder.js.map